"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var datapoints_1 = require("../datapoints");
var getCalendarViewService_1 = require("../services/getCalendarViewService");
var store_1 = require("../store/store");
var legacy_1 = require("satcheljs/lib/legacy");
var NUMBER_OF_DAYS_TO_LOAD = 2;
var addCalendarItemsToStore = legacy_1.action('addCalendarItemsToStore')(function addCalendarItemsToStore(calendarItems, items) {
    calendarItems.clear();
    if (items) {
        for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
            var item = items_1[_i];
            calendarItems.set(item.ItemId.Id, item);
        }
    }
});
exports.default = legacy_1.action('loadCalendarEvents', datapoints_1.default.loadCalendarEvents)(legacy_1.select({
    calendarItems: function () { return store_1.default.calendarItems; },
    today: function () { return new Date(); },
})(function loadCalendarEvents(state) {
    // 1 millisecond so we are really at the beginning of today.
    var today = state.today, calendarItems = state.calendarItems;
    today.setHours(0, 0, 0, 1);
    var queryStart = today;
    var queryEnd = new Date(today); // today + NUMBER_OF_DAYS_TO_LOAD
    queryEnd.setDate(queryStart.getDate() + NUMBER_OF_DAYS_TO_LOAD);
    // TODO: Task 538: Handle failure from the server call
    return getCalendarViewService_1.default(queryStart, queryEnd).then(function (items) {
        addCalendarItemsToStore(calendarItems, items);
    });
}));
//# sourceMappingURL=loadCalendarEvents.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-upnext/lib/actions/loadCalendarEvents.js
// module id = 4813
// module chunks = 48